// @flow
import { Subject } from 'rxjs';

type ProfileNotificationType =
  | 'parentalControlsSettingsSaved'
  | 'parentalControlsSettingsSaveError'
  | 'passcodeUpdated'
  | 'passcodeUpdateError';

export type ProfileNotification = {|
  type: ProfileNotificationType,
|};

export const profileNotificationsEmitter = new Subject<ProfileNotification>();
export const profileNotifications$ = profileNotificationsEmitter.asObservable();
